/* eslint-disable max-lines */
// This file is auto-generated by scripts/scss-routine.js. Do not edit manually.
export const colorStatusError50 = '#e35738';
export const colorStatusError10 = '#ffeaea';
export const colorStatusWarning50 = '#ffc107';
export const colorStatusWarning10 = '#fff8e3';
export const colorStatusSuccess50 = '#12b76a';
export const colorStatusSuccess10 = '#ecfdf3';
export const colorStatusInfo50 = '#2e90fa';
export const colorStatusInfo10 = '#eff8ff';
export const colorPrimary100 = '#a61d47';
export const colorPrimary50 = '#d6083b';
export const colorPrimaryA10 = 'rgba(160, 40, 66, 0.1)';
export const colorDefaultGray100 = '#28282a';
export const colorDefaultGray80 = '#48484a';
export const colorDefaultGray60 = '#8e8e93';
export const colorDefaultGray50 = '#bebebf';
export const colorDefaultGray40 = '#cbcbcc';
export const colorDefaultGray30 = '#e2e2e2';
export const colorDefaultGray10 = '#f4f4f4';
export const colorDefaultGray5 = '#f2f3f5';
export const colorDefaultGray0 = '#f2f2f2';
export const colorDefaultGrayA80 = 'rgba(40, 40, 42, 0.8)';
export const colorDefaultGrayA50 = 'rgba(40, 40, 42, 0.5)';
export const colorDefaultGrayA40 = 'rgba(40, 40, 42, 0.4)';
export const colorDefaultGrayA30 = 'rgba(40, 40, 42, 0.3)';
export const colorDefaultGrayA20 = 'rgba(40, 40, 42, 0.2)';
export const colorDefaultGrayA10 = 'rgba(40, 40, 42, 0.1)';
export const colorDefaultGrayA5 = 'rgba(40, 40, 42, 0.05)';
export const colorDefaultWhite100 = '#fff';
export const colorDefaultWhiteA80 = 'rgba(255, 255, 255, 0.8)';
export const colorDefaultWhiteA50 = 'rgba(255, 255, 255, 0.5)';
export const colorDefaultWhiteA30 = 'rgba(255, 255, 255, 0.3)';
export const colorDefaultWhiteA20 = 'rgba(255, 255, 255, 0.2)';
export const colorDefaultWhiteA10 = 'rgba(255, 255, 255, 0.1)';
export const colorDefaultWhiteA5 = 'rgba(255, 255, 255, 0.05)';
export const colorDefaultFuchsia = '#e40f7e';
export const colorDefaultOrange = '#e9830c';
export const colorDefaultDarkPrimary = '#28282a';
export const colorDefaultDarkSecondary = '#2c2c2c';
export const colorDefaultDarkTertiary = '#424242';
export const colorDefaultLightTextPrimary = '#28282a';
export const colorDefaultLightTextSecondary = 'rgb(40 40 42 / 50%)';
export const colorDefaultDarkTextPrimary = '#fff';
export const colorDefaultDarkTextSecondary = 'rgba(255, 255, 255, 0.5)';
export const colorThemeLightBgPrimary = '#fff';
export const colorThemeLightBgSecondary = '#f4f4f4';
export const colorThemeLightBgTertiary = '#e2e2e2';
export const colorThemeLightTextPrimary = '#28282a';
export const colorThemeLightTextSecondary = '#8e8e93';
export const colorThemeLightBorderPrimary = '#e2e2e2';
export const colorThemeLightBorderSecondary = 'rgb(40 40 42 / 40%)';
export const colorThemeLightAccent = '#a61d47';
export const colorThemeDarkBgPrimary = '#28282a';
export const colorThemeDarkBgSecondary = '#2c2c2c';
export const colorThemeDarkBgTertiary = '#48484a';
export const colorThemeDarkTextPrimary = '#fff';
export const colorThemeDarkTextSecondary = 'rgba(255, 255, 255, 0.5)';
export const colorThemeDarkBorderPrimary = '#48484a';
export const colorThemeDarkBorderSecondary = 'rgb(255 255 255 / 40%)';
export const colorThemeDarkAccent = '#d6083b';
export const colorThemeDarkBtnSecondaryBg = 'rgba(255, 255, 255, 0.1)';
export const colorThemeDarkBtnSecondaryText = '#fff';
export const colorThemeDarkBtnSecondaryBgHover = 'rgba(255, 255, 255, 0.2)';
export const colorThemeDarkBtnSecondaryTextHover = 'rgba(255, 255, 255, 0.5)';
export const colorThemeDarkBtnSecondaryBgDisabled = 'rgba(255, 255, 255, 0.05)';
export const colorThemeDarkBtnSecondaryTextDisabled = 'rgba(255, 255, 255, 0.3)';
export const colorThemePriveBgPrimary = '#28282a';
export const colorThemePriveBgSecondary = '#2c2c2c';
export const colorThemePriveBgTertiary = '#424242';
export const colorThemePriveTextPrimary = '#fff';
export const colorThemePriveTextSecondary = 'rgba(255, 255, 255, 0.5)';
export const colorThemePriveBorderPrimary = '#424242';
export const colorThemePriveBorderSecondary = 'rgb(255 255 255 / 40%)';
export const colorThemePriveAccent = '#d6083b';
export const colorThemePriveBtnSecondaryBg = 'rgba(255, 255, 255, 0.1)';
export const colorThemePriveBtnSecondaryText = '#fff';
export const colorThemePriveBtnSecondaryBgHover = 'rgba(255, 255, 255, 0.2)';
export const colorThemePriveBtnSecondaryTextHover = 'rgba(255, 255, 255, 0.5)';
export const colorThemePriveBtnSecondaryBgDisabled = 'rgba(255, 255, 255, 0.05)';
export const colorThemePriveBtnSecondaryTextDisabled = 'rgba(255, 255, 255, 0.3)';
export const colorAdditionalYellow60 = '#f4a844';
export const colorAdditionalYellow50 = '#ffad1c';
export const colorAdditionalYellow10 = '#f8ecd6';
export const colorAdditionalGreen60 = '#036635';
export const colorAdditionalGreen50 = '#3ec76f';
export const colorAdditionalGreen10 = '#e5f6ee';
export const colorAdditionalBlue10 = '#e0f3f5';
export const colorAdditionalGreenOnlineEcom = '#57966a';
export const colorAdditionalGreenOnlineEcomBg = '#d7f3c1';
export const colorSpecialBlue = '#3548f5';
export const colorSpecialViolet = '#9a29f2';
export const colorPromoExclusive = '#f0e9fb';
export const colorAdditionalMetroViolet60 = '#702785';
export const colorAdditionalMetroViolet50 = '#800080';
export const colorAdditionalMetroBlue100 = '#039';
export const colorAdditionalMetroBlue80 = '#0078be';
export const colorAdditionalMetroBlue50 = '#00bfff';
export const colorAdditionalMetroRed50 = '#ef161e';
export const colorAdditionalMetroOrange60 = '#ea7125';
export const colorAdditionalMetroOrange50 = '#ed9121';
export const colorAdditionalMetroOrange40 = '#f5a71b';
export const colorAdditionalMetroBrown50 = '#8d5b2d';
export const colorAdditionalMetroGreen60 = '#68b668';
export const colorAdditionalMetroGreen50 = '#2dbe2c';
export const colorAdditionalMetroGreen30 = '#9c0';
export const colorAdditionalMetroPink50 = '#e66ac0';
export const colorAdditionalMetroPink30 = '#ffa8af';
export const colorAdditionalMetroYellow50 = '#f6cc00';
export const colorAdditionalMetroMint50 = '#82c0c0';
export const colorAdditionalMetroGray50 = '#bcbcbc';
export const colorGradientRadial = 'radial-gradient(#28282a 0%, #a61d47 79.8%, #28282a 100%)';
export const colorGradientHorizontal = 'linear-gradient(90deg, #28282a 0%, #a61d47 100%)';
export const colorGradientVertical = 'linear-gradient(180deg, #28282a 0%, #a61d47 100%)';
export const colorStatusSuccess40 = '#72d072';
export const colorPrimary80 = '#262f38';
export const colorPrimary70 = '#354f69';
export const colorPrimary60 = '#697b8c';
export const colorPrimary30 = '#b2c7e0';
export const colorPrimary30A20 = 'rgba(178, 199, 224, 0.2)';
export const colorPrimary30A40 = 'rgba(178, 199, 224, 0.4)';
export const colorPrimary20 = '#cddef3';
export const colorPrimary10 = '#f0f2f5';
export const colorPrimary5 = '#f1f7ff';
export const colorSecondary100 = '#8c1327';
export const colorSecondary80 = '#c8102e';
export const colorDefaultGray90 = 'rgb(14 18 27 / 50%)';
export const colorDefaultGray70 = '#6f6f6f';
export const colorDefaultGrayA65 = 'rgba(40, 40, 42, 0.65)';
export const colorDefaultGray34 = 'rgb(178 199 224 / 34%)';
export const colorDefaultGray20 = '#ebebeb';
export const colorDefaultBlack100 = '#000';
export const colorDefaultBlackA80 = 'rgba(0, 0, 0, 0.8)';
export const colorDefaultBlackA50 = 'rgba(0, 0, 0, 0.5)';
export const colorDefaultBlackA40 = 'rgba(0, 0, 0, 0.4)';
export const colorDefaultBlackA30 = 'rgba(0, 0, 0, 0.3)';
export const colorDefaultBlackA25 = 'rgba(0, 0, 0, 0.25)';
export const colorDefaultBlackA20 = 'rgba(0, 0, 0, 0.2)';
export const colorDefaultBlackA15 = 'rgba(0, 0, 0, 0.15)';
export const colorDefaultBlackA10 = 'rgba(0, 0, 0, 0.1)';
export const colorDefaultWhiteA90 = 'rgba(255, 255, 255, 0.9)';
export const colorDefaultWhiteA70 = 'rgba(255, 255, 255, 0.7)';
export const colorAdditionalYellow100 = '#ca9400';
export const colorAdditionalYellow30 = '#ffe59d';
export const colorAdditionalYellowGreen80 = '#d0df00';
export const colorAdditionalGrayBlue80 = '#667e99';
export const colorAdditionalGrayBlue60 = '#8598ad';
export const colorAdditionalGrayBlue50 = '#b3bfcc';
export const colorAdditionalGrayBlue30 = '#e0e7eb';
export const colorAdditionalGrayBlue20 = '#f0f3f5';
export const colorAdditionalLightBlue90 = '#40bcfb';
export const colorAdditionalLightBlue80 = '#71c5e8';
export const colorAdditionalShadowBlueA4 = 'rgb(178 199 224 / 40%)';
export const colorAdditionalShadowBlueA3 = 'rgba(83, 113, 149, 0.3)';
export const colorAdditionalShadowBlueA2 = 'rgb(83 113 149 / 20%)';
export const colorCustomWhite70 = 'rgb(255 255 255 / 70%)';
export const colorCustomDark100 = '#2c303e';
export const colorCustomDark90 = '#14161a';
export const colorCustomOnyx100 = '#343b3f';
export const colorCustomGray50 = '#89898a';
export const colorAdditionalGreen80 = '#3d7e5b';
export const colorAdditionalGreen20 = '#ecf9f2';
export const colorAdditionalYellow80 = '#c45f2e';
export const colorAdditionalYellow20 = '#fbefe9';
export const colorAdditionalPrimary10 = '#fbe9ef';
export const colorAdditionalPrimary20 = '#fbe9e9';
export const colorAdditionalRed30 = '#d92626';
export const colorAdditionalRedA10 = 'rgba(217, 38, 38, 0.1)';
export const colorAdditionalRed10 = '#faaebe';
export const colorAdditionalRed20 = '#fa3a20';
export const colorAdditionalBlue20 = '#eeedf8';
export const colorAdditionalBlue50 = '#6250bc';
export const colorButtonBrand = '#7a2038';

export const Colors = {
    colorStatusError50,
    colorStatusError10,
    colorStatusWarning50,
    colorStatusWarning10,
    colorStatusSuccess50,
    colorStatusSuccess10,
    colorStatusInfo50,
    colorStatusInfo10,
    colorPrimary100,
    colorPrimary50,
    colorPrimaryA10,
    colorDefaultGray100,
    colorDefaultGray80,
    colorDefaultGray60,
    colorDefaultGray50,
    colorDefaultGray40,
    colorDefaultGray30,
    colorDefaultGray10,
    colorDefaultGray5,
    colorDefaultGray0,
    colorDefaultGrayA80,
    colorDefaultGrayA50,
    colorDefaultGrayA40,
    colorDefaultGrayA30,
    colorDefaultGrayA20,
    colorDefaultGrayA10,
    colorDefaultGrayA5,
    colorDefaultWhite100,
    colorDefaultWhiteA80,
    colorDefaultWhiteA50,
    colorDefaultWhiteA30,
    colorDefaultWhiteA20,
    colorDefaultWhiteA10,
    colorDefaultWhiteA5,
    colorDefaultFuchsia,
    colorDefaultOrange,
    colorDefaultDarkPrimary,
    colorDefaultDarkSecondary,
    colorDefaultDarkTertiary,
    colorDefaultLightTextPrimary,
    colorDefaultLightTextSecondary,
    colorDefaultDarkTextPrimary,
    colorDefaultDarkTextSecondary,
    colorThemeLightBgPrimary,
    colorThemeLightBgSecondary,
    colorThemeLightBgTertiary,
    colorThemeLightTextPrimary,
    colorThemeLightTextSecondary,
    colorThemeLightBorderPrimary,
    colorThemeLightBorderSecondary,
    colorThemeLightAccent,
    colorThemeDarkBgPrimary,
    colorThemeDarkBgSecondary,
    colorThemeDarkBgTertiary,
    colorThemeDarkTextPrimary,
    colorThemeDarkTextSecondary,
    colorThemeDarkBorderPrimary,
    colorThemeDarkBorderSecondary,
    colorThemeDarkAccent,
    colorThemeDarkBtnSecondaryBg,
    colorThemeDarkBtnSecondaryText,
    colorThemeDarkBtnSecondaryBgHover,
    colorThemeDarkBtnSecondaryTextHover,
    colorThemeDarkBtnSecondaryBgDisabled,
    colorThemeDarkBtnSecondaryTextDisabled,
    colorThemePriveBgPrimary,
    colorThemePriveBgSecondary,
    colorThemePriveBgTertiary,
    colorThemePriveTextPrimary,
    colorThemePriveTextSecondary,
    colorThemePriveBorderPrimary,
    colorThemePriveBorderSecondary,
    colorThemePriveAccent,
    colorThemePriveBtnSecondaryBg,
    colorThemePriveBtnSecondaryText,
    colorThemePriveBtnSecondaryBgHover,
    colorThemePriveBtnSecondaryTextHover,
    colorThemePriveBtnSecondaryBgDisabled,
    colorThemePriveBtnSecondaryTextDisabled,
    colorAdditionalYellow60,
    colorAdditionalYellow50,
    colorAdditionalYellow10,
    colorAdditionalGreen60,
    colorAdditionalGreen50,
    colorAdditionalGreen10,
    colorAdditionalBlue10,
    colorAdditionalGreenOnlineEcom,
    colorAdditionalGreenOnlineEcomBg,
    colorSpecialBlue,
    colorSpecialViolet,
    colorPromoExclusive,
    colorAdditionalMetroViolet60,
    colorAdditionalMetroViolet50,
    colorAdditionalMetroBlue100,
    colorAdditionalMetroBlue80,
    colorAdditionalMetroBlue50,
    colorAdditionalMetroRed50,
    colorAdditionalMetroOrange60,
    colorAdditionalMetroOrange50,
    colorAdditionalMetroOrange40,
    colorAdditionalMetroBrown50,
    colorAdditionalMetroGreen60,
    colorAdditionalMetroGreen50,
    colorAdditionalMetroGreen30,
    colorAdditionalMetroPink50,
    colorAdditionalMetroPink30,
    colorAdditionalMetroYellow50,
    colorAdditionalMetroMint50,
    colorAdditionalMetroGray50,
    colorGradientRadial,
    colorGradientHorizontal,
    colorGradientVertical,
    colorStatusSuccess40,
    colorPrimary80,
    colorPrimary70,
    colorPrimary60,
    colorPrimary30,
    colorPrimary30A20,
    colorPrimary30A40,
    colorPrimary20,
    colorPrimary10,
    colorPrimary5,
    colorSecondary100,
    colorSecondary80,
    colorDefaultGray90,
    colorDefaultGray70,
    colorDefaultGrayA65,
    colorDefaultGray34,
    colorDefaultGray20,
    colorDefaultBlack100,
    colorDefaultBlackA80,
    colorDefaultBlackA50,
    colorDefaultBlackA40,
    colorDefaultBlackA30,
    colorDefaultBlackA25,
    colorDefaultBlackA20,
    colorDefaultBlackA15,
    colorDefaultBlackA10,
    colorDefaultWhiteA90,
    colorDefaultWhiteA70,
    colorAdditionalYellow100,
    colorAdditionalYellow30,
    colorAdditionalYellowGreen80,
    colorAdditionalGrayBlue80,
    colorAdditionalGrayBlue60,
    colorAdditionalGrayBlue50,
    colorAdditionalGrayBlue30,
    colorAdditionalGrayBlue20,
    colorAdditionalLightBlue90,
    colorAdditionalLightBlue80,
    colorAdditionalShadowBlueA4,
    colorAdditionalShadowBlueA3,
    colorAdditionalShadowBlueA2,
    colorCustomWhite70,
    colorCustomDark100,
    colorCustomDark90,
    colorCustomOnyx100,
    colorCustomGray50,
    colorAdditionalGreen80,
    colorAdditionalGreen20,
    colorAdditionalYellow80,
    colorAdditionalYellow20,
    colorAdditionalPrimary10,
    colorAdditionalPrimary20,
    colorAdditionalRed30,
    colorAdditionalRedA10,
    colorAdditionalRed10,
    colorAdditionalRed20,
    colorAdditionalBlue20,
    colorAdditionalBlue50,
    colorButtonBrand,
} as const;

export type TColorName = keyof typeof Colors;

export type TColorValue = (typeof Colors)[TColorName];

export type TColorMap = typeof Colors;
